// API base resolution:
// - Native Capacitor WebView: hit the public API directly (no proxy available)
// - Everywhere else (CRA dev via setupProxy.js, ui5 serve via /api proxy in
//   ui5.yaml, standalone prod served from the API origin): use relative path
//   so same-origin / dev-proxy rules just work.
const API_BASE = (() => {
  const isNative = !!(window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform());
  return isNative ? 'https://qr.homealerts.app/api/V1.1' : '/api/V1.1';
})();

export async function controlDevice(uuid, device_id, account_type, command, guestCode) {
  const res = await fetch(`${API_BASE}/qr/users`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      appToken: 'qRt0ke4bRLCp5p4d5z1Cc6n616',
      task: 'guestDeviceControl',
      uuid, device_id, account_type, command,
      ...(guestCode ? { verifyCode: guestCode } : {})
    })
  });
  return res.json();
}

export async function fetchDeviceStatus(uuid, device_id, account_type) {
  const res = await fetch(`${API_BASE}/qr/users`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ appToken: 'qRt0ke4bRLCp5p4d5z1Cc6n616', task: 'guestDeviceStatus', uuid, device_id, account_type })
  });
  return res.json();
}

export async function initGuestAccess(uuid) {
  const res = await fetch(`${API_BASE}/qr/users`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ appToken: 'qRt0ke4bRLCp5p4d5z1Cc6n616', task: 'initGuestAccess', uuid })
  });
  return res.json();
}

export async function verifyGuestAccess(uuid, verifyCode) {
  const res = await fetch(`${API_BASE}/qr/users`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ appToken: 'qRt0ke4bRLCp5p4d5z1Cc6n616', task: 'verifyGuestAccess', uuid, verifyCode })
  });
  return res.json();
}

export async function askGuestChatbot(uuid, message, conversationId, history) {
  const res = await fetch(`${API_BASE}/qr/users`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      appToken: 'qRt0ke4bRLCp5p4d5z1Cc6n616',
      task: 'guestChatbotAsk',
      uuid,
      message,
      ...(conversationId ? { conversationId } : {}),
      ...(history ? { history } : {})
    })
  });
  return res.json();
}

export async function fetchLocationData(uuid) {
  const opts = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ appToken: 'qRt0ke4bRLCp5p4d5z1Cc6n616', task: 'getQR', uuid }),
  };
  let lastError;
  for (let attempt = 0; attempt < 3; attempt++) {
    try {
      const res = await fetch(`${API_BASE}/qr/users`, opts);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return await res.json();
    } catch (err) {
      lastError = err;
      if (attempt < 2) await new Promise(r => setTimeout(r, 1000 * (attempt + 1)));
    }
  }
  throw lastError;
}